(() => {
  if (!document.body.classList.contains('template-product') || window.everactivSupportClearance) return;
  window.everactivSupportClearance = true;

  const mobile = window.matchMedia('(max-width: 760px)');
  const body = document.body;
  const controlSelector = '.pdp-purchase-panel .submit, .pdp-purchase-panel .overlay-dynamic_buy_button .shopify-payment-button, #sticky-add-to-cart:not(.align-top)';
  const appSelectors = {
    'shopify-chat': '.activator',
    'gty-whatsapp-chat-button': '.gty-wacb-wrapper'
  };
  const appRoots = new Map();
  const observedElements = new Set();
  let controls = [];
  let launchers = [];
  let frame = 0;
  let lastOffset = '';
  let needsRefresh = true;

  function schedule(refresh = false) {
    needsRefresh = needsRefresh || refresh === true;
    if (!frame) frame = requestAnimationFrame(update);
  }

  const resizeObserver = new ResizeObserver(() => schedule());
  const controlObserver = new MutationObserver(() => schedule());
  const contentObserver = new MutationObserver(() => schedule(true));
  const stateObserver = new MutationObserver(() => schedule());

  function refreshElements() {
    controls = [...document.querySelectorAll(controlSelector)];
    launchers = [];
    const currentRoots = new Set();

    Object.entries(appSelectors).forEach(([tag, selector]) => {
      document.querySelectorAll(tag).forEach(host => {
        const root = host.shadowRoot;
        if (!root) return;
        const roots = [root, root.querySelector('shopify-agent-runtime')?.shadowRoot].filter(Boolean);
        roots.forEach(appRoot => {
          currentRoots.add(appRoot);
          if (!appRoots.has(appRoot)) {
            const observer = new MutationObserver(() => schedule(true));
            observer.observe(appRoot, { childList: true, subtree: true });
            appRoots.set(appRoot, observer);
          }
          const launcher = appRoot.querySelector(selector);
          if (launcher) launchers.push(launcher);
        });

        // WhatsApp has no exposed CSS part; only override its launcher's position.
        if (tag === 'gty-whatsapp-chat-button' && !root.getElementById('everactiv-support-clearance')) {
          const style = document.createElement('style');
          style.id = 'everactiv-support-clearance';
          style.textContent = '@media (max-width: 760px) { .gty-wacb-wrapper { bottom: var(--pdp-support-bottom, 16px) !important; } }';
          root.append(style);
        }

      });
    });

    appRoots.forEach((observer, root) => {
      if (!currentRoots.has(root)) {
        observer.disconnect();
        appRoots.delete(root);
      }
    });

    const elements = new Set([...controls, ...launchers]);
    observedElements.forEach(element => {
      if (!elements.has(element)) {
        resizeObserver.unobserve(element);
        observedElements.delete(element);
      }
    });
    elements.forEach(element => {
      if (!observedElements.has(element)) {
        resizeObserver.observe(element);
        observedElements.add(element);
      }
    });

    controlObserver.disconnect();
    controls.forEach(element => controlObserver.observe(element, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
    }));
    needsRefresh = false;
  }

  function visibleRect(element) {
    const sticky = element.id === 'sticky-add-to-cart';
    if (!sticky && element.getAttribute('aria-hidden') === 'true') return null;
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    const style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.display === 'none' || (!sticky && style.opacity === '0')) return null;
    if (sticky && style.position === 'fixed') {
      // Reserve its settled height throughout the theme's entrance/exit transition.
      rect.y = window.innerHeight - (parseFloat(style.bottom) || 0) - rect.height;
    }
    return rect;
  }

  function update() {
    frame = 0;
    if (!mobile.matches) {
      body.style.removeProperty('--pdp-support-clearance');
      lastOffset = '';
      return;
    }
    if (needsRefresh) refreshElements();

    const viewportHeight = window.innerHeight;
    const safeBottom = parseFloat(getComputedStyle(body).getPropertyValue('--pdp-support-safe-bottom')) || 0;
    const launcherHeight = Math.max(48, ...launchers.map(element => visibleRect(element)?.height || 0));
    const rects = controls.map(visibleRect)
      .filter(rect => rect && rect.bottom > 0 && rect.top < viewportHeight)
      .sort((a, b) => b.bottom - a.bottom);

    // Start from the resting position, not the shifted one, to avoid feedback/jitter.
    let bottom = viewportHeight - 16 - safeBottom;
    rects.forEach(rect => {
      if (rect.top < bottom + 12 && rect.bottom > bottom - launcherHeight - 12) {
        bottom = Math.min(bottom, rect.top - 12);
      }
    });
    const offset = `${Math.ceil(viewportHeight - bottom)}px`;
    if (offset !== lastOffset) {
      body.style.setProperty('--pdp-support-clearance', offset);
      lastOffset = offset;
    }
  }

  contentObserver.observe(body, { childList: true, subtree: true });
  stateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  [...Object.keys(appSelectors), 'shopify-agent-runtime'].forEach(tag => customElements.whenDefined(tag).then(() => schedule(true)));
  mobile.addEventListener('change', () => schedule(true));
  window.addEventListener('scroll', () => schedule(), { passive: true });
  window.addEventListener('resize', () => schedule(), { passive: true });
  window.visualViewport?.addEventListener('resize', () => schedule(), { passive: true });
  window.addEventListener('pageshow', () => schedule(true));
  document.addEventListener('load', () => schedule(), true);
  ['transitionrun', 'transitionend', 'transitioncancel'].forEach(type => {
    document.addEventListener(type, event => {
      if (event.target.id === 'sticky-add-to-cart') schedule();
    });
  });
  schedule(true);
})();


(function moveSnapmintToProductHeader() {
	'use strict';
	if (!document.querySelector('[data-snapmint-slot]')) {
		return;
	}

	function moveWidget() {
		var slot = document.querySelector('[data-snapmint-slot]');
		var widget = document.getElementById('sm-widget-btn');
		if (slot && widget && widget.parentElement !== slot) {
			slot.appendChild(widget);
		}
	}

	moveWidget();
	document.addEventListener('DOMContentLoaded', moveWidget);
	window.addEventListener('load', moveWidget);
	new MutationObserver(moveWidget).observe(document.documentElement, {
		childList: true,
		subtree: true
	});
}());

;(function keepReviewCloseAccessible() {
  'use strict';
  if (!window.location.pathname.includes('/products/')) return;

  const observedButtons = new WeakSet();

  function bindCloseButtons() {
    document.querySelectorAll('.jdgm-write-review-modal__close-btn').forEach(function (button) {
      if (observedButtons.has(button)) return;
      observedButtons.add(button);

      function restoreAccess() {
        if (button.hasAttribute('aria-hidden')) button.removeAttribute('aria-hidden');
        if (button.getAttribute('tabindex') !== '0') button.setAttribute('tabindex', '0');
      }

      restoreAccess();
      new MutationObserver(restoreAccess).observe(button, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex']
      });
    });
  }

  function initialize() {
    bindCloseButtons();
    new MutationObserver(bindCloseButtons).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
